// A hover card is portaled out of the list it belongs to, so a wheel event over
// the card has no DOM path back to the list's scroller. Forwarding needs that
// element found from the anchor the card is placed against.
export function findScrollableAncestor(
  element: HTMLElement | null
): HTMLElement | null {
  for (
    let node = element?.parentElement ?? null;
    node;
    node = node.parentElement
  ) {
    const { overflowY } = getComputedStyle(node)
    if (
      (overflowY === 'auto' || overflowY === 'scroll') &&
      node.scrollHeight > node.clientHeight
    ) {
      return node
    }
  }

  // Radix's ScrollArea viewport is the scroller in every list this is used
  // from. It only reaches here when the walk above cannot read a computed
  // overflow — a test environment, or a viewport not yet overflowing.
  return (
    element?.closest<HTMLElement>('[data-radix-scroll-area-viewport]') ?? null
  )
}

// Whether an element has room left to scroll in the direction of a wheel delta.
// A card that has run out of room is what hands the gesture on to the list.
export function canScrollFurther(
  element: HTMLElement,
  deltaY: number
): boolean {
  if (element.scrollHeight <= element.clientHeight) {
    return false
  }
  if (deltaY > 0) {
    return (
      Math.ceil(element.scrollTop + element.clientHeight) < element.scrollHeight
    )
  }
  if (deltaY < 0) {
    return element.scrollTop > 0
  }
  return false
}
